import { AutocompleteItem } from "../../components/Autocomplete";
import { defaultCountry } from "../../shared";

import { filterEmpty } from "./filterEmpty";

export const generateAddress = (
  data: Record<string, string | AutocompleteItem | boolean>
): string =>
  [
    [data["street"] as string, data["street2"] as string].join(" ").trim(),
    [
      (data["zipCodePL"] as string) ||
        (data["zipCodeGeneric"] as string) ||
        (data["zipCode"] as string),
      data["city"] as string,
    ]
      .join(" ")
      .trim(),
    [
      (data["country"] as AutocompleteItem)?.value === defaultCountry.value
        ? (data["province"] as string)
        : "",
      (data["country"] as AutocompleteItem)?.label as string,
    ]
      .join(" ")
      .trim(),
  ]
    .filter(filterEmpty)
    .join(", ");
